import keyMirror from 'react-utils/keyMirror';
export const DragTypes = keyMirror({
  NEW_FORM_FIELD: null,
  NEW_RECAPTCHA: null,
  REORDER_FORM_FIELD: null,
  REORDER_RICH_TEXT: null,
  PROPERTY_OPTION_SORT: null
});